@if(!form) {
<a [routerLink]="link"
   [class.is-disabled]="!basket.isSalable"
   cy-checkoutProceed
   class="w-12 button">
    {{ basketAddConfirmationText ? ('Go to basket' | translate) : ('Checkout securely' | translate) }}
</a>
}

@if(form) {
<button (click)="submit()"
        [class.is-disabled]="!basket.isSalable"
        cy-checkoutProceed
        class="w-12 button">
    {{ basketAddConfirmationText ? ('Go to basket' | translate) : ('Checkout securely' | translate) }}
</button>
}

@if (!basket.isSalable) {
  <p
    class="p2 col-2 m-t-2"
  translate>To proceed to checkout please remove out of stock products from your basket</p>
}
